import React from 'react';
import { Link } from 'react-router-dom';
import { TeamRoleCard } from '../../../cards';
import styles from './adultTeamTennisRoles.scss';

const AdultTeamTennisRoles = (props) => {
    const { clubDetails, isAdminOrOwner, typeOfTeamRolesName, clubType, auth, sendMessage } = props;
    const { teamRoles, clubOrganizers } = clubDetails;
    return (
        <div>
            <h6>{typeOfTeamRolesName}</h6>
            {teamRoles && teamRoles.length ? (
                <div className={`${styles.teamRoles}`}>
                    {teamRoles.map((teamRole, i) => {
                        return (
                            <TeamRoleCard
                                key={`teamRole-${i}`}
                                teamRole={teamRole}
                                user={auth.user}
                                clubOrganizers={clubOrganizers}
                                sendMessage={sendMessage}
                            />
                        );
                    })}
                </div>
            ) : (
                <div className={`${styles.teamRolesEmpty}`}>
                    <p>No {typeOfTeamRolesName} added</p>
                </div>
            )}
            {isAdminOrOwner && (
                <div className="mt8">
                    <Link to={`/${clubType}/${clubDetails.id}/teams/captains/manage`} className={`${styles.manageTeamRoles} underline`}>Manage {typeOfTeamRolesName}</Link>
                </div>
            )}
        </div>
    );
};

export default AdultTeamTennisRoles;
